import React, {PropTypes} from "react";
import {connect} from "react-redux";
import SummaryTable from "./SummaryTable";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Modal from "react-bootstrap/lib/Modal";
import LedgerTable from "./LedgerTable";
import moment from "moment";
import toastr from "toastr";
import {DateRange} from "react-date-range";
import * as actions from "../../../redux/actions/leaveActions";
class LeaveApply extends React.Component {

  constructor() {
    super();
    this.state = {
      showDialog: false, startDate: null, endDate: null, value: "EL", leaveType: "Earned Leave",
      show: true, comment: null, optional: false, optionalDate: null, error: "hi", request: null
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.props.changeBanner("Apply Leave");
    this.props.dispatch(actions.getLeaveBalance());
    this.props.dispatch(actions.getLeaveLedger());
  }

  close() {
    this.setState({showDialog: false});
  }

  handleSelect(range) {
    this.setState({startDate: range.startDate, endDate: range.endDate});
    // An object with two keys,
    // 'startDate' and 'endDate' which are Momentjs objects.
  }

  render() {
  console.log(this.props);
    let gender=null;
    if(this.props.employee)
    {if(this.props.employee[0])
      if(this.props.employee[0].personal)
      {
        gender = this.props.employee[0].personal.gender;
      }
    }



    return (
      <div>
        <h3 className="tab_drawer_heading" rel="apply">
          Apply leave
        </h3>
        <div role="tabpanel" className="tab-pane" id="apply">
          <div className="row clearfix">
            <div className="col-md-7">
              <div className="inner-col-wrap">
                <h2 style={{ marginTop: 5 }}>Select Leave Type</h2>
                <form
                  ref="leave"
                  name="apply"
                  onSubmit={(event) => {
                    event.preventDefault();
                    if (!this.state.optional) {
                      var eD = new Date(this.state.endDate);
                      var request = {
                        leaveType: this.state.value,
                        endDate: this.state.endDate.format(),
                        startDate: this.state.startDate.format(),
                        leaveReason: this.state.comment,
                      };
                      this.setState({ showDialog: true, request: request });
                    } else {
                      if (
                        this.state.optionalDate == "Select Date" ||
                        this.state.optionalDate == null
                      )
                        toastr.error("Kindly select date");
                      else {
                        var request = {
                          leaveType: "OL",
                          endDate: this.state.optionalDate,
                          startDate: this.state.optionalDate,
                          leaveReason: this.state.comment,
                        };
                        this.setState({ showDialog: true, request: request });
                      }
                    }
                    return 1;
                  }}
                >
                  <div className="form-group">
                    <SelectField
                      labelStyle={{ color: "#1E88E5" }}
                      style={{ width: "75%" }}
                      defaultValue="Earned Leave"
                      value={this.state.value}
                      onChange={(option, data, value) => {
                        if (value == "OL")
                          this.setState({ optional: true, show: false });
                        else
                          this.setState({
                            optional: false,
                            show: true,
                            optionalDate: null,
                          });
                        this.setState({ value: value, comment: null });
                      }}
                    >
                      <MenuItem value="EL" primaryText="Earned Leave" />
                      <MenuItem value="OL" primaryText="Optional Leave" />

                      <MenuItem value="CL" primaryText="Compassionate Leave" />
                      <MenuItem value="MrL" primaryText="Marriage Leave" />
                      <MenuItem value="LWP" primaryText="Leave Without Pay" />
                      {gender == "F" ? (
                        <MenuItem
                          value="ML-L"
                          primaryText="Maternity Leave (182days)"
                        />
                      ) : (
                        <MenuItem value="PL" primaryText="Paternity Leave" />
                      )}
                      {gender == "F" ? (
                        <MenuItem
                          value="ML-S"
                          primaryText="Maternity Leave (42days)"
                        />
                      ) : (
                        <MenuItem />
                      )}
                    </SelectField>
                    <br />
                    {!this.state.optional ? (
                      <div>
                        <h2>
                          <u>Select Dates</u>
                        </h2>
                        {1 && this.state.startDate ? (
                          <label style={{ color: "#1E88E5", fontSize: "18" }}>
                            <font color="black">From:</font>{" "}
                            {this.state.startDate.format("LL")} <br />
                            <font color="black">To:</font>{" "}
                            {this.state.endDate.format("LL")}
                          </label>
                        ) : null}
                        {this.state.show ? (
                          <DateRange
                            style={{ borderStyle: "line" }}
                            onInit={this.handleSelect}
                            onChange={this.handleSelect}
                          />
                        ) : null}
                        <div
                          className="row form-group clearfix"
                          style={{ marginBottom: "5" }}
                        >
                          <div className="form-group">
                            <br />
                            <label style={{ fontSize: "15" }}>
                              Reason for leave
                            </label>
                            <textarea
                              ref="leaves"
                              disabled={false}
                              value={this.state.comment}
                              onChange={(event) => {
                                this.setState({ comment: event.target.value });
                              }}
                              className="form-control"
                              rows="2"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <label style={{ fontSize: "15" }}>
                          Select Optional Leave Date
                        </label>
                        <br />
                        <SelectField
                          labelStyle={{ color: "#1E88E5" }}
                          style={{ width: "75%" }}
                          defaultValue={null}
                          value={this.state.optionalDate}
                          onChange={(option, data, value) => {
                            this.setState({ optionalDate: value });
                            this.setState({
                              comment:
                                this.props.optional.optional[data - 1].name,
                            });
                          }}
                        >
                          <MenuItem value={null} primaryText="&nbsp;" />
                          {this.props.optional.optional.map((node) => {
                            const date = moment(node.date);
                            if (date.isValid()) {
                              const now = moment();
                              const color = now > date ? "#A9A9A9" : undefined;
                              console.debug(
                                "Optional holiday",
                                node.name,
                                node.date,
                                date,
                                now,
                                color
                              );
                              return (
                                <MenuItem
                                  value={date.format().substr(0, 10)}
                                  primaryText={
                                    date.toString().substr(0, 11) +
                                    " " +
                                    node.name
                                  }
                                  style={{ backgroundColor: color }}
                                />
                              );
                            } else return <MenuItem value={null} />;
                          })}
                        </SelectField>{" "}
                        <br />
                        <br />
                      </div>
                    )}
                    <button type="submit" className="btn btn-default btn-lg">
                      Apply Leave
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {this.state.value == "EL" ? (
              <SummaryTable props={this.props.summary} />
            ) : null}
          </div>

          <Modal show={this.state.showDialog} onHide={this.close}>
            <Modal.Header closeButton>
              <Modal.Title>Apply Leave</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h4>Your Leave Application</h4>
              {this.state.request == null ? null : (
                <div>
                  <p>Leave Type: {this.state.request.leaveType}</p>
                  {this.state.request.leaveType != "OL" ? (
                    <div>
                      <p>
                        Leave Dates: {this.state.startDate.format("LL")}-
                        {this.state.endDate.format("LL")}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <p>Leave Date: {this.state.optionalDate}</p>
                    </div>
                  )}
                  <p>Reason for Leave: {this.state.comment}</p>
                </div>
              )}

              <hr />
              <button
                onClick={() => {
                  this.setState({ showDialog: false, show: true, comment: "" });

                  this.props.dispatch(actions.applyLeave(this.state.request));
                }}
                className="btn btn-default"
              >
                Apply
              </button>
              <button
                style={{ marginLeft: "10%" }}
                onClick={() => {
                  this.setState({ showDialog: false });
                }}
                className="btn btn-default"
              >
                Cancel
              </button>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }

}

LeaveApply.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    optional: state.leave[1],
    summary: state.leave[0],
    ledger: state.leave[6].ledger,
    status: state.emp[0].status,
    employee: state.emp
  };

}

export default connect(mapStateToProps)(LeaveApply);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveApply/LeaveApply.js
 **/